import React from 'react';
import { EyeIcon } from 'lucide-react';
export function InformationCollection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2775">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-8" data-id="element-2776">
        <div className="flex items-center gap-3 mb-4" data-id="element-2777">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
          backgroundColor: 'rgba(30,61,47,0.08)'
        }} data-id="element-2778">
            <EyeIcon size={20} style={{
            color: '#1e3d2f'
          }} data-id="element-2779" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2780">
            Information Collection, Use, and Sharing
          </h2>
        </div>
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2781">
          <div className="space-y-4" data-id="element-2782">
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2783">
              We are the sole owners of the information collected on this site.
              We only have access to/collect information that you voluntarily
              give us via email or other direct contact from you. We will not
              sell or rent this information to anyone.
            </p>
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2784">
              We will use your information to respond to you, regarding the
              reason you contacted us. We will not share your information with
              any third party outside of our organization, other than as
              necessary to fulfill your request, e.g. to ship an order.
            </p>
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2785">
              Unless you ask us not to, we may contact you via email in the
              future to tell you about specials, new products or services, or
              changes to this privacy policy.
            </p>
          </div>
        </div>
      </div>
    </div>;
}